import React from 'react';
import './footer.css';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import SocialLinks from '../SocialLinks/SocialLinks';
import { profile } from '../../data/profile';

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div className="footer-brand">
          <span className="footer-name">{profile.name}</span>
          <span className="footer-role">{profile.headline}</span>
        </div>

        <SocialLinks />

        <div className="footer-meta">
          <span>© {year} {profile.name}</span>
          <a className="footer-top" href="#top" aria-label="Back to top">
            Back to top
            <KeyboardArrowUpIcon fontSize="small" />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
